/**
 * collection.js
 *
 * The filter and sort controls are a plain GET form and work without this
 * file. All this adds is submitting on change, so a visitor does not have to
 * find an Apply button after choosing a sort order.
 */

document.addEventListener('change', (event) => {
  const control = event.target.closest('[data-auto-submit]');
  if (!control) return;

  const form = control.closest('form');
  if (form) form.submit();
});
